export const groups = {
    read(options) {
        return $.getJSON(AdminRoutes.adminAPIV3GroupsPath(options));
    },

    readProfileAssignments(id) {
        return $.getJSON(AdminRoutes.adminGroupProfileAssignmentsPath(id));
    },

    assignProfile(id, profileId) {
        return $.ajax({
            method:   'POST',
            dataType: 'json',
            contentType: "application/json",
            url:      AdminRoutes.adminGroupProfileAssignmentsPath(id),
            data:     JSON.stringify({ profileId })
        });
    },

    unassignProfile(id, profileId) {
        return $.ajax({
            method:   'DELETE',
            dataType: 'json',
            contentType: "application/json",
            url:      AdminRoutes.adminGroupProfileAssignmentPath(id, profileId),
        });
    }
};